/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext, useEffect } from "react";
import { Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import Context from "../../../../store/context";
import JsonCollapse from "../../../Components/JsonCollapse";
import CommonInput from "../Inputs/CommonInput";
import labels from "../helpers/labels";
import actionOptionsConfig from "./actionOptionsConfig";
import Errors from "../../../Components/Errors";

export default function ActionOptions({
  dispatch,
  action,
  rule,
  event,
  eventListener,
}) {
  const navigate = useNavigate();
  const params = useParams();
  const pageProps = JSON.parse(
    document.querySelector("#app").dataset.page
  ).props;
  const context = useContext(Context);
  const location = useLocation();

  return (
    <>
      <Link
        to={`/library/logic/builder/${params.projectID}/workflow/${params.workflowUUID}/event/${params.event}/listener/${params.listenerUUID}/action/${action.UUID}`}
        className="btn btn-outline-primary ms-1 border-0"
      >
        <Errors
          filterFn={(error) => error.action?.UUID === action.UUID}
          exclamationMarkOnly
          linkDisabled
        />
        <FontAwesomeIcon icon={faCog} className="me-2" />
        Options
      </Link>
      <Offcanvas
        show={params.actionUUID === action.UUID}
        placement="end"
        className="action-options-modal"
        backdropClassName="action-options-modal-backdrop"
        onHide={() => {
          navigate(
            location.state?.nextPage ||
              `/library/logic/builder/${params.projectID}/workflow/${params.workflowUUID}/event/${params.event}/listener/${params.listenerUUID}`
          );
        }}
        style={{ width: 800 }}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            <FontAwesomeIcon icon={faCog} /> Action options -{" "}
            {labels[action.Type]}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {params.actionUUID === action.UUID &&
            // inputs
            actionOptionsConfig({
              action,
              context,
              eventListener,
              pageProps,
              params,
              rule,
              event,
              dispatch,
              navigate,
            })[action.Type]?.inputs?.map((input, i) => (
              <CommonInput
                className={`mb-5 bg-purple-gradient p-2 rounded-2 ${
                  input.className || ""
                } ${input.group ? "d-inline-block align-top" : ""}`}
                key={`${action.UUID}-${input.field || input.label}-${i}${
                  input.props?.key
                }-${input.props?.keyValue}`}
                {...{
                  input,
                  condition: action,
                  setCondition: (newAction) =>
                    dispatch({
                      type: "edit-action",
                      actionId: action.UUID,
                      newAction,
                    }),
                }}
              />
            ))}

          <JsonCollapse json={action} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
